export default __webpack_public_path__ + "images/DEEPECHO_logo_white.0e0c647dded004c8f8c3527f149548b7.png";